<template>
  <v-container fluid>
    <v-row class="mx-4">
      <!-- <v-col class="py-0">
        <v-autocomplete
          v-model="filters.segmentacao_clientes"
          :loading="loading.filters || loading.table"
          title="Segmentação dos clientes"
          label="Segmentação dos clientes"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.segmentacao_clientes"
        ></v-autocomplete>
      </v-col> -->

      <v-col class="py-0">
        <v-autocomplete
          v-model="filters.causa_raiz"
          :loading="loading.filters || loading.table"
          title="Causa"
          label="Causa"
          multiple
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.causa_raiz"
        ></v-autocomplete>
      </v-col>

      <!-- <v-col class="py-0">
        <v-autocomplete
          v-model="filters.comentario_da_causa"
          :loading="loading.filters || loading.table"
          title="Subcausa"
          label="Subcausa"
          dense
          multiple
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.comentario_da_causa"
        ></v-autocomplete>
      </v-col> -->

      <!-- <v-col class="py-0">
        <v-autocomplete
          v-model="filters.canal_compra"
          :loading="loading.filters || loading.table"
          title="Canal da compra"
          label="Canal da compra"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.canal_compra"
        ></v-autocomplete>
      </v-col> -->

      <v-col class="py-0">
        <v-text-field
          v-model="filters.id"
          title="id"
          label="ID"
          single-line
          dense
          clearable
        ></v-text-field>
      </v-col>

      <v-col class="py-0">
        <v-autocomplete
          v-model="filters.loja"
          :loading="loading.filters || loading.table"
          title="Loja"
          label="Loja"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.loja"
        ></v-autocomplete>
      </v-col>

      <v-col class="py-0">
        <v-autocomplete
          v-model="filters.marca"
          :loading="loading.filters || loading.table"
          title="Marca"
          label="Marca"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.marca"
        ></v-autocomplete>
      </v-col>

      <v-col class="py-0">
        <v-autocomplete
          v-model="filters.categoria_prato"
          :loading="loading.filters || loading.table"
          title="categoria_prato"
          label="Categoria Prato"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.categoria_prato"
        ></v-autocomplete>
      </v-col>

      <v-col class="py-0">
        <v-autocomplete
          v-model="filters.priorizacao"
          :loading="loading.filters || loading.table"
          title="Priorização"
          label="Priorização"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.priorizacao"
        ></v-autocomplete>
      </v-col>

      <!-- <v-col class="py-0">
        <v-autocomplete
          v-model="filters.regional_loja"
          :loading="loading.filters || loading.table"
          title="Regional da loja"
          label="Regional da loja"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.regional_loja"
        ></v-autocomplete>
      </v-col> -->

      <!-- <v-col class="py-0">
        <v-autocomplete
          v-model="filters.divisao"
          :loading="loading.filters || loading.table"
          title="Divisão"
          label="Divisão"
          dense
          clearable
          item-disabled="disabled"
          :disabled="loading.filters || loading.table"
          :items="items.divisao"
        ></v-autocomplete>
      </v-col> -->

      <v-col class="py-0">
        <v-menu
          ref="picker_data_da_entrevista"
          v-model="pickers.data_da_entrevista"
          :close-on-content-click="false"
          :return-value.sync="filters.data_da_entrevista"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="data_da_entrevista_label"
              :loading="loading.filters || loading.table"
              title="Data da participação"
              label="Data da participação"
              @click:clear="filters.data_da_entrevista = []"
              prepend-icon="mdi-calendar"
              clearable
              dense
              persistent-hint
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            range
            locale="pt-BR"
            v-model="filters.data_da_entrevista"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="pickers.data_da_entrevista = false"
              >Cancelar</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="
                $refs.picker_data_da_entrevista.save(filters.data_da_entrevista)
              "
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col class="py-0">
        <v-menu
          ref="picker_data_da_visita"
          v-model="pickers.data_da_visita"
          :close-on-content-click="false"
          :return-value.sync="filters.data_da_visita"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="data_da_visita_label"
              :loading="loading.filters || loading.table"
              title="Data da visita"
              label="Data da visita"
              @click:clear="filters.data_da_visita = []"
              prepend-icon="mdi-calendar"
              clearable
              dense
              persistent-hint
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            range
            locale="pt-BR"
            v-model="filters.data_da_visita"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="pickers.data_da_visita = false"
              >Cancelar</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="$refs.picker_data_da_visita.save(filters.data_da_visita)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    email: "",
    accessList: [
      // "raphael.anjos@qwst.co",
      "",
    ],
    timeout: null,
    pickers: {
      data_da_entrevista: false,
      data_da_visita: false,
    },
    filters: {
      // id_loja: "",
      // segmentacao_clientes: "",
      causa_raiz: "",
      // comentario_da_causa: "",
      // canal_compra: "",
      loja: "",
      marca: "",
      categoria_prato: "",
      // regional_loja: "",
      // divisao: "",
      data_da_entrevista: [],
      data_da_visita: [],
      id: "",
      priorizacao: "",

    },
    items: {
      // id_loja: [],
      // segmentacao_clientes: [],
      // canal_compra: [],
      causa_raiz: [],
      // comentario_da_causa: [],
      loja: [],
      marca: [],
      categoria_prato: [],
      // regional_loja: [],
      // divisao: [],
      data_da_entrevista: [],
      data_da_visita: [],
      id: [],
      priorizacao: [],
    },
  }),

  computed: {
    ...mapState(["loading", "params"]),

    data_da_entrevista_label() {
      return this.filters.data_da_entrevista.join(" ~ ");
    },
    data_da_visita_label() {
      return this.filters.data_da_visita.join(" ~ ");
    },
  },

  watch: {
    status() {
      this.clean();
    },
    filters: {
      handler() {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        if (
          !this.loading.filters &&
          this.filters.data_da_entrevista.length !== 1 &&
          this.filters.data_da_visita.length !== 1
        ) {
          this.timeout = setTimeout(() => {
            this.confirm();
            this.timeout = null;
          }, 500);
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations(["setParams", "setLoading"]),
    ...mapActions(["getTable", "getHeaders"]),

    clean() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.confirm();
    },

    confirm() {
      this.setParams({
        id_status: `${this.status}`,
        id: this.filters.id || "",
        loja: this.filters.loja || "",
        marca: this.filters.marca || "",
        categoria_prato: this.filters.categoria_prato || "",
        causa_raiz: this.filters.causa_raiz || "",
        priorizacao: this.filters.priorizacao || "",
        data_da_entrevista_ini: this.filters.data_da_entrevista[0] || "",
        data_da_entrevista_fin:
          this.filters.data_da_entrevista[
            this.filters.data_da_entrevista.length - 1
          ] || "",
        data_da_visita_ini: this.filters.data_da_visita[0] || "",
        data_da_visita_fin:
          this.filters.data_da_visita[this.filters.data_da_visita.length - 1] ||
          "",
      });
      this.fetchLoja();
      // this.fetchID();
      this.fetchMarca();
      this.fetchCategoriaPrato();
      this.fetchCausa();
      this.getTable();
    },

    async reload(key) {
      this.confirm();
      if (key === "loja") {
        this.fetchLoja();
        // this.fetchID();
        this.fetchMarca();
        this.fetchCategoriaPrato();
        this.fetchCausa();
        this.fetchPriorizacao();
      } else {
        if (key === "id") {
          this.fetchLoja();
          // this.fetchID();
          this.fetchMarca();
          this.fetchCategoriaPrato();
          this.fetchCausa();
          this.fetchPriorizacao();
        }
        if (key === "marca") {
          this.fetchLoja();
          // this.fetchID();
          this.fetchMarca();
          this.fetchCategoriaPrato();
          this.fetchCausa();
          this.fetchPriorizacao();
        }
        if (key === "categoria_prato") {
          this.fetchLoja();
          // this.fetchID();
          this.fetchMarca();
          this.fetchCategoriaPrato();
          this.fetchCausa();
          this.fetchPriorizacao();
        }
        if (key === "causa_raiz") {
          this.fetchLoja();
          // this.fetchID();
          this.fetchMarca();
          this.fetchCategoriaPrato();
          this.fetchCausa();
          this.fetchPriorizacao();
        }
      }
    },

    fetchLoja() {
      this.setLoading({ loading: { filters: true } });
      const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

      var obj = Object.assign(this.params, { field: "loja" });

      fetch(`${api}/filtros/list`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        method: "POST",
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          this.items.loja = res;
          this.setLoading({ loading: { filters: false } });
        });
    },
    // fetchID() {
    //   this.setLoading({ loading: { filters: true } });
    //   const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

    //   var obj = Object.assign(this.params, { field: "id" });

    //   fetch(`${api}/filtros/list`, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "application/json",
    //       Authorization: process.env.VUE_APP_AUTHORIZATION,
    //     },
    //     method: "POST",
    //     body: JSON.stringify(obj),
    //   })
    //     .then((res) => res.json())
    //     .then((res) => {
    //       this.items.id = res;
    //       this.setLoading({ loading: { filters: false } });
    //     });
    // },
    fetchMarca() {
      this.setLoading({ loading: { filters: true } });
      const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

      var obj = Object.assign(this.params, { field: "marca" });

      fetch(`${api}/filtros/list`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        method: "POST",
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          this.items.marca = res;
          this.setLoading({ loading: { filters: false } });
        });
    },
    fetchCategoriaPrato() {
      this.setLoading({ loading: { filters: true } });
      const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

      var obj = Object.assign(this.params, { field: "categoria_prato" });

      fetch(`${api}/filtros/list`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        method: "POST",
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          this.items.categoria_prato = res;
          this.setLoading({ loading: { filters: false } });
        });
    },
    fetchCausa() {
      this.setLoading({ loading: { filters: true } });
      const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

      var obj = Object.assign(this.params, { field: "causa_raiz" });

      fetch(`${api}/filtros/list`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        method: "POST",
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          this.items.causa_raiz = res;
          this.setLoading({ loading: { filters: false } });
        });
    },
    fetchPriorizacao() {
      //console.log("estou aqui");
      this.setLoading({ loading: { filters: true } });
      const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

      var obj = Object.assign(this.params, { field: "priorizacao" });

      fetch(`${api}/filtros/list`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        method: "POST",
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          this.items.priorizacao = res;
          this.setLoading({ loading: { filters: false } });
        });
    },
  },

  async mounted() {
    this.email = this.$route.query.pad_email || this.email;
    // this.email = "raphael.anjos@qwst.co";
    this.fetchLoja();
    // this.fetchID();
    this.fetchMarca();
    this.fetchCategoriaPrato();
    this.fetchCausa();
    this.fetchPriorizacao();

    this.confirm();
  },
  // beforeMount() {
  //   let pad_email = localStorage.getItem("pad_email");
  //   this.userEmail = pad_email;
  // },
};
</script>